import React, { useState } from "react";

const InputImage = ({
  name,
  onChange,
  placeholder,
  label,
  minSize,
  maxSize,
  required,
  readOnly,
  isEditMode,
  setInputImgError,
  multiple,
}) => {
  const [errorMsg, setErrorMsg] = useState("");

  const handleFileChange = (event) => {
    const files = multiple
      ? Array.from(event.target.files)
      : [event.target.files[0]];
    let validFiles = [];
    let hasError = false;

    files.forEach((file) => {
      if (file) {
        if (multiple) {
          if (file.size < 10 * 1024 || file.size > 1 * 1024 * 1024) {
            setErrorMsg("Selected file must be between 10 KB and 1 MB.");
            hasError = true;
          } else if (!validateImageFile(file)) {
            setErrorMsg("Only PNG, JPG, and JPEG formats are allowed.");
            hasError = true;
          } else {
            validFiles.push(file);
          }
        } else {
          if (!validateImageFile(file)) {
            setErrorMsg("Only PNG, JPG, and JPEG formats are allowed.");
            hasError = true;
          } else if (minSize && file.size < minSize) {
            setErrorMsg(
              `File size should be greater than ${minSize / 1024} KB.`
            );
            hasError = true;
          } else if (maxSize && file.size > maxSize) {
            setErrorMsg(
              `File size should be less than ${maxSize / (1024 * 1024)} MB.`
            );
            hasError = true;
          } else {
            validFiles.push(file);
          }
        }
      }
    });

    setInputImgError((previousState) => ({
      ...previousState,
      image: hasError,
    }));

    if (validFiles.length > 0) {
      setErrorMsg("");
      onChange(multiple ? validFiles : validFiles[0]);
    } else if (!isEditMode) {
      onChange(null);
    }
  };

  const validateImageFile = (file) => {
    const allowedTypes = ["image/jpg", "image/png", "image/jpeg"];
    return allowedTypes.includes(file.type);
  };

  return (
    <div className="form-group">
      <label htmlFor="image-upload" className="col-form-label">
        {label}
      </label>
      <input
        type="file"
        className="form-control"
        name={name}
        id="image-upload"
        accept=".png, .jpg, .jpeg"
        onChange={handleFileChange}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
        multiple={multiple}
      />
      {errorMsg && <small className="text-danger">{errorMsg}</small>}
    </div>
  );
};

export default InputImage;
